import React from 'react';

const EmojiWrapper = ({ name, emoji }) => {
  return (
    <span role="img" aria-label={`${name}-emoji`}>
      {emoji}
    </span>
  );
}


export default EmojiWrapper;
